<div class="main-dashboard-container">
  <div class="column-container">
    <div class="card dark-card">
      <div class="card-icon-container">
        <mat-icon ngClass="card-icon" aria-hidden="false" aria-label="File copy">
          file_copy
        </mat-icon>
      </div>
      <div class="card-value-container">
        <span class="card-number"><animated-counter [digit]="totals"></animated-counter></span>
        <span class="card-description">Document Total</span>
      </div>
    </div>

    <div
      *ngFor="let card of clientCardConfigurations"
      class="card"
      [style.background]="card.backgroundColor"
    >
      <div class="card-value-container">
        <span class="card-number"><animated-counter [digit]="card.count"></animated-counter></span>
        <span class="card-description">In {{ card.label }}</span>
      </div>
    </div>
  </div>
  <div class="column-container">
    <div *ngFor="let data of configuration" class="data-column">
      <span class="job-name">{{ data.label }}</span>
      <div class="job-count-container">
        <span>Total: <animated-counter [digit]="data.count"></animated-counter></span>
      </div>
      <p-chart
        #chart
        type="bar"
        [options]="chartOptions"
        [data]="data.channelGraph"
        (onDataSelect)="onDataSelect($event)"
      ></p-chart>
    </div>
  </div>
</div>

<div class="settings-container">
  <h3>Refresh Rate</h3>
  <p-dropdown
    (onChange)="changeRefreshRate()"
    [options]="refreshOptions"
    [formControl]="refreshRate"
  ></p-dropdown>
</div>
